export const ROLES = Object.freeze(['owner', 'socio', 'organizador', 'administracion', 'rrpp', 'imagen', 'porteria', 'barra', 'pendiente']);

export function normalizarRol(value) {
  const rol = String(value || '').trim().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
  return rol === 'anfitrion' ? 'imagen' : rol;
}
